import React from 'react'
import NumberFormatInput from './NumberFormatInput'
import { Input, InputGroup } from 'components/ui'

const InputWithDescription = (props) => {
    const Hint = <span className="text-xs text-gray-500">民國年月日</span>

    return <Input {...props} suffix={Hint} />
}

const placeholderHint = '(YYY MM DD)'

const RocDateInput = ({ onChange, ...rest }) => {
    return <NumberFormatInput
        {...rest}
        onValueChange={onChange}
        format="### ## ##"
        customInput={InputWithDescription}
        placeholder={rest.placeholder + ' ' + placeholderHint}
    />
}

export default RocDateInput